app.service('opinionAnswers',function(validate, loading, modal, productCardConfig, front, captchaService) {
	var $lessAnswers, $moreAnswers, $questionAnswerButton;

	function showLess(link){
		$(link).closest('.verified-answers').addClass('verified-answers-limited');
	}
	function showMore(link){
		$(link).closest('.verified-answers').removeClass('verified-answers-limited');
	}
	function getForm(id) {
		$.ajax({
			url:'/opinion-answer-form.ltr',
			type:'GET',
			cache:false,
			data: {
				'question': id
			},
			success: function(html) {
				$('#answer-mode-form' + id).html(html).addClass('form-visible');
				formComplete(id);
				addOpinionAnswerCaptcha(id);
			}
		});
	}
	function formComplete(id) {
		setValidator(id);
	}
	function addOpinionAnswerCaptcha(id) {
		let $captcha = $('#answer-form' + id).find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	function setValidator(id) {
		validate.task('opinionAnswer', {id:id,submit:submit});
	}
	function hideForm(id) {
		$('#answer-mode-form' + id).html('').removeClass('form-visible');
	}
	function submit(form) {
		var id=$(form).data('id');
		$(form).ajaxSubmit({
			beforeSubmit:function(){
				loading.start();
			},
			url:'/opinion-answer-form.ltr?question='+id,
			data:{chandelier:parseInt(new Date().getTime()/3786)},
			target:'#answer-mode-form' + id,
			success: function(html) {
				loading.stop();
				formComplete(id);
				UA.interaction('KP', 'Opinie', 'Odpowiedz na pytanie - Wysłane');
				$('#answer-mode-form' + id).find('textarea.hasEditor').wysiwyg();
				addOpinionAnswerCaptcha(id);
			},error:function(){
				loading.stop();
				modal.alert('Wystąpił błąd w komunikacji z serwerem. Prosimy spróbować później');
			}
		});
	}
	function setEvents(){
		$lessAnswers.on('click',function(){
			showLess($(this));
		});
		$moreAnswers.on('click',function(){
			showMore($(this));
		});
		$questionAnswerButton.on('click', function(){
			if(front.katalog){
				window.open(productCardConfig.getData().euroUrl+'#opinie');
			}else{
				getForm($(this).data('id'));
				UA.interaction('KP', 'Opinie', 'Odpowiedz na pytanie');
			}
		});
		$self.on('click', '.js-answer-cancel', function(){
			hideForm($(this).data('id'));
		});
	}
	function setElements(){
		$lessAnswers = $self.find('.js-less-answers');
		$moreAnswers = $self.find('.js-more-answers');
		$questionAnswerButton = $self.find('.js-question-answer-button');
	}
	function init(){
		$self = $('#opinion-list');
		setElements();
		setEvents();
	}
	return {
		init: init,
	};
});
